import { call, put, takeLatest } from 'redux-saga/effects';
import axios from 'axios';
import config from '../../../config';
import { getLocalUser } from '../../../utils/localUser';
import { REQUEST, fetchSuccess, fetchFailure } from '../../actions/marketplace/listingSuggestion';
import { extractErrorMessage } from '../../../utils/apiResponseHandler';

// Cheap deferred suggestion fetch for the publish wizard. This is a
// best-effort helper: failures are SOFT — the wizard simply renders
// without pre-filled fields. Intentionally no global Error dispatch
// so a suggest hiccup never surfaces a snackbar mid-publish.
function* process(action) {
  const { signalKey } = action.payload || {};
  try {
    const url = `${config.API_URL}/marketplace/listings/suggest?signal_key=${encodeURIComponent(signalKey)}`;
    const response = yield call(axios.get, url, { headers: getLocalUser() });
    yield put(fetchSuccess(response?.data?.data || response?.data || null));
  } catch (error) {
    yield put(fetchFailure(extractErrorMessage(error)));
  }
}

export function* watch() {
  yield takeLatest(REQUEST, process);
}
